<template>
  <div class="text-textColor">
    <!-- loader -->
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute toppest bg-black bg-opacity-80 h-screen w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition>
    <!-- register success -->
    <transition name="fade">
      <div
        v-if="showEnrollementSuccess"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md sm:w-1/3 w-full shadow-2xl"
        >
          <div class="flex justify-end items-center p-3">
            <img
              class="h-5 object-contain bg-primary rounded-md cursor-pointer hover:shadow-lg"
              src="@/assets/icons/cross-white.png"
              @click="showEnrollementSuccess = false"
            />
          </div>
          <div>
            <div class="px-10 pb-9">
              <img
                class="h-12 mx-auto object-contain"
                src="@/assets/icons/check.png"
              />
              <p class="text-center pt-5">
                {{ enrollementSuccess }}
              </p>
            </div>
          </div>
        </div>
      </div>
      >
    </transition>

    <div class="h-screen grid grid-cols-1 lg:grid-cols-2 w-full relative">
      <features class="hidden lg:block"></features>
      <div>
        <div class="flex justify-center h-full flex-col px-20">
          <div class="text-textColorGray">
            <div class="py-2 sm:py-5 sm:px-0 px-10">
              <h1 class="text-4xl pb-5 font-bold">Register Company</h1>
              <h1 class="text-sm">
                Please add your company details to register
              </h1>
            </div>
            <!-- login form -->
            <form class="w-full sm:px-0 px-10" @submit.prevent="register">
              <!-- register error -->
              <transition name="fade">
                <div
                  v-if="error"
                  class="text-xs border-1.5 border-red-400 mb-6 flex items-center p-2 gap-4"
                >
                  <img class="h-5" src="@/assets/icons/cross.png" />
                  <p class="font-bold">{{ error }}</p>
                </div>
              </transition>
              <div
                class="grid lg:grid-cols-2 grid-cols-1 lg:gap-5 gap-10 items-center"
              >
                <div class="flex flex-col">
                  <label for="OrganizationName">Name</label>
                  <input
                    id="OrganizationName"
                    v-model="info.OrganizationName"
                    required
                    type="text"
                    placeholder="Company Name*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="OrganizationAddress">Address</label>
                  <input
                    id="OrganizationAddress"
                    v-model="info.OrganizationAddress"
                    required
                    type="text"
                    placeholder="Physical Loaction*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="OrganizationEmail">Email</label>
                  <input
                    id="OrganizationEmail"
                    v-model="info.OrganizationEmail"
                    required
                    type="email"
                    placeholder="Company Contact Email*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="TotalManagers">Number of Managers</label>
                  <input
                    id="TotalManagers"
                    v-model="info.TotalManagers"
                    required
                    type="number"
                    min="1"
                    placeholder="Total Number of Managers*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="TotalNormalEmployees">Number of Employees</label>
                  <input
                    id="TotalNormalEmployees"
                    v-model="info.TotalNormalEmployees"
                    required
                    min="1"
                    type="number"
                    placeholder="Total Number of Normal Employees*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="">
                  <label for="OrganizationPhoneNumber">Phone Number</label>
                  <div
                    class="w-full flex items-center gap-2 p-2 text-sm border-0.5 border-inputBorder rounded"
                  >
                    <p>+254</p>
                    <input
                      id="OrganizationPhoneNumber"
                      v-model="info.OrganizationPhoneNumber"
                      type="tel"
                      maxlength="9"
                      placeholder="Phone No.* +254 000 000 000"
                      class="w-full rounded-full focus:outline-none"
                    />
                  </div>
                </div>

                <div class="flex flex-col">
                  <label for="CR12">CR12 Certificate</label>
                  <input
                    id="CR12"
                    v-on:change="getFile"
                    required
                    type="file"
                    placeholder="CR12*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="CompanyRegistration"
                    >Company Registration Certificate</label
                  >
                  <input
                    id="CompanyRegistration"
                    v-on:change="getFile"
                    required
                    type="file"
                    placeholder="Company Registration*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="flex flex-col">
                  <label for="BusinessPermit">Business Permit</label>
                  <input
                    id="BusinessPermit"
                    v-on:change="getFile"
                    required
                    type="file"
                    placeholder="Business Permit*"
                    class="text-xs font-semibold rounded-full border-1.5 p-2"
                  />
                </div>

                <div class="text-sm font-semibold md:col-span-2 mb-1">
                  <input type="checkbox" />
                  <label>
                    Accept our
                    <a href="#" class="text-primary">Terms and Conditions</a>
                  </label>
                </div>
              </div>
              <button
                type="submit"
                class="bg-primary hover:bg-primary text-white p-2 sm:p-3 mt-0 sm:mt-6 rounded-full font-semibold text-sm w-full"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import features from "@/components/carousel/features.vue";
import axios from "axios";
import Loader from "../components/loader/loader.vue";
export default {
  name: "Register",
  components: {
    features,
    Loader,
  },
  data() {
    return {
      info: {
        OrganizationName: "",
        TotalManagers: "",
        TotalNormalEmployees: "",
        OrganizationEmail: "",
        OrganizationPhoneNumber: "",
        OrganizationAddress: "",
        BusinessPermit: "",
        CR12: "",
        CompanyRegistration: "",
      },
      error: null,
      loading: false,
      showEnrollementSuccess: false,
      enrollementSuccess: null,
    };
  },
  methods: {
    register() {
      this.loading = true;
      const options = {
        headers: {
          accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      };

      //console.log(this.info)

      const formData = new FormData();
      formData.append("OrganizationName", this.info.OrganizationName);
      formData.append("TotalManagers", this.info.TotalManagers);
      formData.append("TotalNormalEmployees", this.info.TotalNormalEmployees);
      formData.append("OrganizationEmail", this.info.OrganizationEmail);
      formData.append(
        "OrganizationPhoneNumber",
        this.info.OrganizationPhoneNumber
      );
      formData.append("OrganizationAddress", this.info.OrganizationAddress);
      formData.append("BusinessPermit", this.info.BusinessPermit);
      formData.append("CR12Certificate", this.info.CR12);
      formData.append("CompanyRegistration", this.info.CompanyRegistration);

      axios
        .post(`/organization/${this.$ApiVersion}/enroll`, formData, options)
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.enrollementSuccess = response.data.StatusMessage;
              this.showEnrollementSuccess = true;
            } else {
              this.error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.error = error.message;
          }
        );
    },

    getFile({ target }) {
      const file = target.files[0];
      switch (target.id) {
        case "CR12":
          this.info.CR12 = file;
          break;
        case "CompanyRegistration":
          this.info.CompanyRegistration = file;
          break;
        case "BusinessPermit":
          this.info.BusinessPermit = file;
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.toppest {
  z-index: 9999999;
}
</style>
